import React, { useEffect } from 'react';
import { Home } from './component/Home';
import { Outlet, isRouteErrorResponse, useLocation, useNavigate, useRouteError } from 'react-router-dom';
import { Button, Result } from 'antd';

import Booking from './component/booking/booking';
import CreateBooking from './component/booking/create-booking/create-booking';
import { Master } from './component/common/Master';
import EditBooking from './component/booking/edit-booking/edit-booking';
import MyVisa from './component/booking/myVisa';
import Vouchers from './component/report/vouchers';
import ActivityOperations from './component/activityoperations/activityoperations';
import UserSettings from './component/profile/userSettings';
import Dashboard from './component/dashboard/dashboard';
import AgentProfile from './component/profile/agentProfile';
import SubUserProfile from './component/profile/subUserProfile';
import CreateRatePlan from './component/ratePlanMaster/createRatePlan';
import AdvanceRatePlan from './component/ratePlanMaster/advanceRatePlan';


function RootBoundary() {
  const error = useRouteError();
  const nav = useNavigate();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={<Button type="primary" onClick={e=>nav('/home/booking')}>Back Home</Button>}
      />;
    }

    if (error.status === 401) {
      return <div>You aren't authorized to see this</div>;
    }

    if (error.status === 503) {
      return <div>Looks like our API is down</div>;
    }

    if (error.status === 418) {
      return <div>🫖</div>;
    }
  }

  return <div>Something went wrong</div>;
}


const RedirectFlow = () => {
  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    if (location.pathname === "/") {
      nav('/home');
    }
  }, [])
  return <Outlet />;
}

export const routeDetail = [
  {
    path: "/",
    element: <RedirectFlow />,
    errorElement: <RootBoundary />,
    children: [
      {
        path: "/home",
        element: <Home />,
        children: [
           
          {
            path: "/home/system/master",
            element: <Master />,
          },
          {
            path: "/home/booking",
            element: <Booking />,
          },
          {
            path: "/home/myVisa",
            element: <MyVisa />,
          },
          {
            path: "/home/report/voucher",
            element: <Vouchers />,
          },
          {
            path: "/home/activityOperations",
            element: <ActivityOperations />,
          },
          {
            path: "/home/userSettings",
            element: <UserSettings />,
          },
          {
            path: "/home/dashboard",
            element: <Dashboard />,
          },          
          {
            path: "/home/booking/create",
            element: <CreateBooking />,
          },
          {
            path: "/home/booking/edit",
            element: <EditBooking />,
          },
          {
            path: "/home/profile/agentProfile",
            element: <AgentProfile />,
          },
          {
            path: "/home/profile/subUserProfile",
            element: <SubUserProfile />,
          },
          {
            path: "/home/ratePlanMaster/createRatePlan",
            element: <CreateRatePlan />,
          },
          {
            path: "/home/ratePlanMaster/advanceRatePlan",
            element: <AdvanceRatePlan />,
          },
        ]
      },
    ],
  },
]